import { ChangeDetectionStrategy, Component } from '@angular/core';
import {
  UiButtonComponent,
  UiInputComponent,
  UiTooltipDirective,
} from '@system-dyg/shared/ui';
import { AppExampleSectionComponent } from '../../components/ds-example-section/ds-example-section.component';

@Component({
  selector: 'app-tooltip-doc',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    UiTooltipDirective,
    UiButtonComponent,
    UiInputComponent,
    AppExampleSectionComponent,
  ],
  templateUrl: './tooltip-doc.component.html',
  styleUrl: './tooltip-doc.component.scss',
})
export class TooltipDocComponent {}
